// This is example of menu item without group for horizontal layout. There will be no children.

// third-party
import { FormattedMessage } from "react-intl";

// ==============================|| MENU ITEMS - SAMPLE PAGE ||============================== //

const newsletter = {
  id: "newsletter",
  title: <FormattedMessage id="newsletters" />,
  type: "group",
  url: "/newsletter",
};

export default newsletter;
